export const PATH_HOME = '/';
export const PATH_LOGIN = '/login';
export const PATH_QUESTION_LIST = '/questions'
export const PATH_QUESTION_EDIT = '/questions/:id'